import { useBooking } from './booking';

export function CTA() {
  const { openBooking } = useBooking();
  return (
    <section id="book" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/img/cta.webp"
          alt=""
          aria-hidden="true"
          loading="lazy"
          width={1920}
          height={1080}
          className="h-full w-full object-cover object-[72%_48%]"
        />
        {/* Lighter wash - dark enough on the left for legible type, the photo
            stays visible across the rest of the band. */}
        <div className="absolute inset-0 bg-gradient-to-r from-navy-deep/85 via-navy-deep/40 to-transparent" />
        <div className="absolute inset-0 bg-navy-deep/15" />
      </div>

      <div className="container-content section-pad relative z-10 py-24 sm:py-32">
        <div className="max-w-xl">
          <p className="eyebrow text-crimson-soft">Limited Dates Each Season</p>
          <h2 className="mt-5 font-display text-[clamp(2.25rem,5.5vw,4rem)] font-medium leading-[1.05] text-white">
            Your story, above the caldera.
          </h2>
          <button
            type="button"
            onClick={() => openBooking(undefined, undefined, 'cta_section')}
            className="btn btn-primary mt-9"
          >
            Reserve Your Session
          </button>
        </div>
      </div>
    </section>
  );
}
